import { render, staticRenderFns } from "./ReceiverForm.vue?vue&type=template&id=3bb8351a&"
import script from "./ReceiverForm.vue?vue&type=script&lang=js&"
export * from "./ReceiverForm.vue?vue&type=script&lang=js&"
import style0 from "./ReceiverForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports